module.exports = __webpack_public_path__ + "static/media/kirkko-parkkipaikat.5205cb65.png";